import ShimmerContainer from '@alltrails/core/components/ShimmerContainer';
import Typography from '@alltrails/core/components/Typography';
import IconTile from '@alltrails/denali/components/IconTile';
import SparkleFilled from '@alltrails/denali/icons/SparkleFilled';
import useAskSuggestions from '@/hooks/useAskSuggestions';
import styles from './AskSidebar.module.scss';

type Props = {
  onSuggestionClick: (question: string) => void;
};

/**
 * What Ask shows before the first question with prompt suggestions. The suggestions are generated for the map's area.
 */
const AskEmptyState = ({ onSuggestionClick }: Props) => {
  const intro = "Let's help you find the perfect trail"; // hwandrew TODO: XPLR-204 translations
  // hwandrew TODO: XPLR-204 translations
  const fallbackSuggestions = ['Shady hikes I can bring my dog on', 'Waterfall hikes under 5 miles', 'Quiet trails with a great view at the top'];
  const loadingLabel = 'Loading suggestions'; // hwandrew TODO: XPLR-204 translations
  const { isLoading, suggestions = fallbackSuggestions } = useAskSuggestions(fallbackSuggestions.length);

  return (
    <div className={styles.emptyState}>
      <IconTile
        className={styles.emptyStateIcon}
        icon={{ Component: SparkleFilled }}
        radius="circle"
        size="lg"
        variant={{ background: 'var(--color-background-primary)', color: 'var(--color-text-primary)' }}
      />
      <Typography mt="0" mb="0" component="h3" variant="heading300">
        {intro}
      </Typography>
      {isLoading ? (
        <div aria-label={loadingLabel} role="status">
          <ShimmerContainer className={styles.suggestions}>
            {fallbackSuggestions.map(suggestion => (
              <div className={styles.suggestionSkeleton} key={suggestion} />
            ))}
          </ShimmerContainer>
        </div>
      ) : (
        <div className={styles.suggestions}>
          {suggestions.map(suggestion => (
            <button className={styles.suggestion} key={suggestion} onClick={() => onSuggestionClick(suggestion)} type="button">
              {suggestion}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default AskEmptyState;
